import React from 'react';
import PropTypes from 'prop-types';

const TableHeader = ({
    isFirstGradeInList,
    isSingleGrade,
    gradeTitle,
    headerCells,
    webEntryClassName,
}) => {
    if (isFirstGradeInList) {
        return (
            <div
                className={`${webEntryClassName}-row-container table-header-container ${
                    isSingleGrade ? 'no-grade' : ''
                }`}
                key={`${gradeTitle}-header-row`}
            >
                <div className="name-container">
                    {!isSingleGrade && <div className="grade-title">{gradeTitle}</div>}
                    <div className="student-column-title student-name">
                        <strong>Last Name</strong>, First Name
                    </div>
                </div>
                <div className="icon-line">
                    {headerCells.map(
                        ({ cellClassName, title, iconClassName, additionalElement }) => (
                            <div key={title} className={`display-container ${cellClassName}`}>
                                <h5>{title}</h5>
                                <div className={iconClassName} />
                                {additionalElement}
                            </div>
                        ),
                    )}
                    <div className="display-container" />
                </div>
            </div>
        );
    }

    return (
        <div className={`${webEntryClassName}-row-container`} key={gradeTitle}>
            <div className="grade-title name-container">{gradeTitle}</div>
        </div>
    );
};

TableHeader.defaultProps = {
    isFirstGradeInList: false,
    headerCells: [],
    gradeTitle: '',
    isSingleGrade: false,
    webEntryClassName: '',
};

TableHeader.propTypes = {
    gradeTitle: PropTypes.string,
    isSingleGrade: PropTypes.bool,
    isFirstGradeInList: PropTypes.bool,
    headerCells: PropTypes.arrayOf(PropTypes.object),
    webEntryClassName: PropTypes.string,
};

export default TableHeader;
